import { FC, useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import cx from 'classnames'
import { Colour } from '../../constants'
import { CmsCardPanelCardTakeover } from '@/components/CardPanel/CardPanelTypes'
import { CardImage } from '../CardImage/CardImage'
import { CardCopy } from '../CardCopy/CardCopy'

export interface CardTakeoverProps {
  shown: boolean
  cardTakeover: CmsCardPanelCardTakeover
  toggleCardTakeover: () => void
  hideImageOnMobile?: boolean
  singleCardRow?: boolean
}

export const CardTakeover: FC<CardTakeoverProps> = ({
  shown,
  cardTakeover,
  toggleCardTakeover = () => {},
  hideImageOnMobile = false,
  singleCardRow = false,
}) => {
  const {
    backgroundColour,
    title,
    subtitle,
    richText,
    bodyCopy,
    imageFit,
    image,
  } = cardTakeover.fields || {}
  const colour = () => backgroundColour || Colour.fuschiaPunch
  const [clickableTakeover, setClickableTakeover] = useState(false)
  const takeoverRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (takeoverRef.current) {
      setClickableTakeover(!takeoverRef.current.querySelectorAll('a').length)
    }
  }, [])

  const handleClick = () => {
    if (shown && clickableTakeover) {
      toggleCardTakeover()
    }
  }

  return (
    <div
      ref={takeoverRef}
      onClick={handleClick}
      className={cx(
        styles.cardTakeover,
        {
          [styles.shown]: shown,
          [styles.clickable]: clickableTakeover,
        },
        styles[colour()],
      )}
    >
      <div
        className={cx(
          styles.overlay,
          { [styles.shown]: shown },
          styles[colour()],
        )}
      />
      <div
        className={cx(styles.inner, { [styles.singleCardRow]: singleCardRow })}
      >
        <CardCopy
          inTakeover
          backgroundColour={backgroundColour}
          title={title}
          subtitle={subtitle}
          bodyCopy={bodyCopy}
          richText={richText}
          className={styles.cardCopy}
          singleCardRow={singleCardRow}
        />

        {image && singleCardRow && (
          <CardImage
            imageFit={imageFit}
            image={image}
            hideImageOnMobile={hideImageOnMobile}
          />
        )}
      </div>
    </div>
  )
}
